import { createAction } from 'redux-actions';
import message from '@itt/frontend-scaffold-components/dist/Message/Message';
import { getUsers } from './service';
import { RESET, SET_TOTAL, SET_USERS, SET_LOADING } from './actionTypes';
import STATUS_CODE from '../../../request/statusCode';
import { assignGroups } from '../../common/service/user';

const setAllUsers = createAction(SET_USERS);

const setTotal = createAction(SET_TOTAL);

const setLoading = createAction(SET_LOADING);

const reset = createAction(RESET);

const getAllUsers = ({ page, size, keyword }) => {
  return dispatch => {
    dispatch(setLoading(true));
    return getUsers({ page, size, keyword }).then(res => {
      dispatch(setLoading(false));
      if (res.statusCode === STATUS_CODE.OK) {
        const { content, totalElements } = res.data;
        dispatch(setAllUsers(content));
        dispatch(setTotal(totalElements));
      } else {
        dispatch(setAllUsers([]));
        dispatch(setTotal(0));
      }
    });
  };
};

const editGroups = ({ groups, userName, keyword, page, size }) => {
  return dispatch => {
    return assignGroups({ groups, userName }).then(res => {
      if (res.statusCode === STATUS_CODE.OK) {
        message.success('Group updated successfully !');
        dispatch(getAllUsers({ page, size, keyword }));
        return true;
      }
      return false;
    });
  };
};

export { getAllUsers, setAllUsers, setTotal, reset, editGroups, setLoading };
